/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable new-cap */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../shared/arial';
import ExamResultsTypeQuiz from './ExamResultsTypeQuiz';
import ExamResultsWithGrades from './ExamResultsWithGrades';
import ExamResultsWithAnswers from './ExamResultsWithAnswers';
import ExamResultsWithFile from './ExamResultsWithFile';
import { Loading } from '../../helpers/utils';
import examModalityServices from '../../redux/services/examModalityServices';
import ExamResultsWithVideo from './ExamResultsWithVideo';
import ExamResultsTypePlacementTest from './ExamResultsTypePlacementTest';

const ExamResults = () => {
  const [examType, setExamType] = useState(null);
  const [examModalities, setExamModalities] = useState([]);
  const location = useLocation();
  const path = location.pathname.split('/');

  const loadExamModality = async () => {
    const examModalitiesRes = await examModalityServices.getExamModality();
    setExamModalities(examModalitiesRes);
  };

  useEffect(() => {
    loadExamModality();
    setExamType(parseInt(path[2], 10));
  }, []);

  const redirectToResults = (type) => {
    if (examType !== null) {
      switch (type) {
        case 0:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
          return <ExamResultsWithGrades grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} examModalities={examModalities} />;
        case 7:
        case 8:
          return <ExamResultsTypeQuiz grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} examModalities={examModalities} />;
        case 6:
          return <ExamResultsTypePlacementTest grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} examModalities={examModalities} />;
        case 2:
        case 4:
          return <ExamResultsWithAnswers grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} examModalities={examModalities} />;
        case 5:
          return <ExamResultsWithVideo grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} examModalities={examModalities} />;
        case 3:
          return <ExamResultsWithFile grpLvl1={path[3]} grpLvl2={path[4]} semester={path[5]} examIdentifier={path[6]} examModalities={examModalities} />;
        default:
          return <Loading />;
      }
    } else {
      return <Loading />;
    }
  };

  return redirectToResults(examType);
};

export default ExamResults;
